import { render, staticRenderFns } from "./progress-bar.vue?vue&type=template&id=6871d7a5&"
import script from "./progress-bar.vue?vue&type=script&lang=js&"
export * from "./progress-bar.vue?vue&type=script&lang=js&"
import style0 from "./progress-bar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6871d7a5', component.options)
    } else {
      api.reload('6871d7a5', component.options)
    }
    module.hot.accept("./progress-bar.vue?vue&type=template&id=6871d7a5&", function () {
      api.rerender('6871d7a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/progress-bar.vue"
export default component.exports